<script setup>
  import { useI18n } from 'vue-i18n'

  import { AUTH_SPONSORS_UI_ENABLED } from '@/features/auth/clubSelfRegistrationConfig.js'
  import SponsorsList from '@/features/auth/layout/sponsors/SponsorsList.vue'
  import { useAuthLayoutStore } from '@/features/auth/layout/useAuthLayoutStore.js'
  import Spinner from '@/features/ui/components/Spinner.vue'

  const props = defineProps({
    grayedBackground: {
      type: Boolean,
      default: false,
    },
  })

  const { t } = useI18n()
  const authLayoutStore = useAuthLayoutStore()
</script>

<template>
  <div
    class="auth-layout-wrapper auth-layout-theme-wrapper"
    :class="{
      loading: authLayoutStore.isLoadingRef,
      'grayed-background': props.grayedBackground,
    }"
  >
    <template v-if="!authLayoutStore.isLoadingRef">
      <RouterView />
      <SponsorsList v-if="AUTH_SPONSORS_UI_ENABLED && authLayoutStore.isClubLogin" />

      <div v-if="authLayoutStore.isClubLogin" class="footer-text-club-login">
        {{ t('login.footer.copyright') }}
      </div>

      <div v-else class="footer-text-fm-login">
        {{ t('login.footer.copyright') }}
      </div>
    </template>

    <template v-else>
      <div class="auth-layout-spinner">
        <Spinner />
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
  .auth-layout-wrapper {
    position: relative;
    min-height: 100dvh;

    display: flex;
    flex-direction: column;
    z-index: 5;

    &:not(.loading) {
      --fm-ui-auth-layout-background-image: url('@/assets/auth/auth-bg.png');
    }

    &::after {
      -webkit-mask-image: linear-gradient(to right, white, transparent);
      background-size: cover;
      background-position: center left;
      background-repeat: no-repeat;
      mask-image: linear-gradient(to right, white, transparent);
      background-image: var(--fm-ui-auth-layout-background-image);

      content: '';
      position: fixed;
      left: 0;
      top: 0;
      bottom: 0;
      width: 50%;
      z-index: -1;
      height: 100dvh;
    }

    &.grayed-background::after {
      opacity: 0.3;
    }
  }

  .footer-text-club-login {
    display: flex;
    text-align: center;
    justify-content: center;
    margin-top: auto;
    padding: 20px 0;
    z-index: 1;
    position: relative;
  }

  @include breakpoint(tablet) {
    .footer-text-club-login {
      background: light-dark(#fff, #121212);
      margin-top: unset;
    }
  }
  @include breakpoint(mobile) {
    .footer-text-club-login {
      display: none;
    }
  }

  .footer-text-fm-login {
    display: flex;
    text-align: center;
    justify-content: center;
    margin-top: auto;
    padding: 20px 0;
    z-index: 1;
    position: relative;
  }

  .auth-layout-spinner {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100dvh;
    width: 100%;
  }
</style>
